import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./LearningCalendarContent.css";
import LearningCalendarComponent from "./LearningCalendarComponent";

function LearningCalendarContent() {

  return (
    <>
      <div className="main-banner">
        <img
          src="images/Home/banner-home.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="learn-calen-container">
        <div className="learn-calen-wrap">
          <LearningCalendarComponent />
        </div>
      </div>
    </>
  );
}

export default LearningCalendarContent;
